export default {"src":"/_next/static/media/icon-general.8b4928a4.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};